import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { getExhibitionMasterDetailsUrl, getExhibitionMasterlistUrl, addExhibitionMasterUrl, updateExhibitionMasterUrl, deleteExhibitionMasterUrl, GET_EXHIBITION_MASTER_DETAILS, GET_EXHIBITION_MASTER_LIST, ADD_EXHIBITION_MASTER, UPDATE_EXHIBITION_MASTER, DELETE_EXHIBITION_MASTER, headers } from "../../../utils/constants";

export const getExhibitionMasterList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getExhibitionMasterlistUrl, params, headers)

        dispatch({
            type: GET_EXHIBITION_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const addExhibitionMaster_action = (Name, Code, countryId, fromDate, toDate, bankDetails) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: null,
            ExhibitionName: Name,
            Code: Code,
            CurrencyID: '',
            CountryID: countryId,
            // Logo: null,
            ExhibitionDateFrom: fromDate,
            ExhibitionDateTo: toDate,
            BankDetails: bankDetails,
            PI_Series: '',
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(addExhibitionMasterUrl, params, headers)

        dispatch({
            type: ADD_EXHIBITION_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateExhibitionMaster_action = (ExhibitionID, Name, Code, countryId, fromDate, toDate, bankDetails) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            ExhibitionName: Name,
            Code: Code,
            CurrencyID: '',
            CountryID: countryId,
            // Logo: null,
            ExhibitionDateFrom: fromDate,
            ExhibitionDateTo: toDate,
            BankDetails: bankDetails,
            PI_Series: '',
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(updateExhibitionMasterUrl, params, headers)

        dispatch({
            type: UPDATE_EXHIBITION_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getExhibitionMasterDetails_action = (ExhibitionID,) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getExhibitionMasterDetailsUrl, params, headers)

        dispatch({
            type: GET_EXHIBITION_MASTER_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteExhibitionMaster_action = (ExhibitionID,) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(deleteExhibitionMasterUrl, params, headers)

        dispatch({
            type: DELETE_EXHIBITION_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}